module.exports = __webpack_public_path__ + "static/media/barcode.fb97a83d.svg";